import { Lifecycle } from '../../device-api/lifecycle';
import { detectPageVisibilityApi } from './page-visibility-api';
export class BrowserLifecycle extends Lifecycle {
    context;
    hiddenAttribute;
    constructor(context) {
        super();
        this.context = context;
        const document = context.document;
        const { hiddenAttribute, visibilityChangeEvent } = detectPageVisibilityApi(document);
        this.hiddenAttribute = hiddenAttribute;
        document.addEventListener(visibilityChangeEvent, () => {
            if (document[this.hiddenAttribute]) {
                this.notify("suspend" /* LifecycleEvent.Suspend */);
            }
            else {
                this.notify("resume" /* LifecycleEvent.Resume */);
            }
        });
        document.addEventListener('fullscreenchange', () => {
            // https://developer.mozilla.org/en-US/docs/Web/API/Document/fullscreen
            // https://developer.mozilla.org/en-US/docs/Web/API/DocumentOrShadowRoot/fullscreenElement
            this.notify("fullscreen" /* LifecycleEvent.Fullscreen */, document.fullscreen || !!document.fullscreenElement);
        });
    }
    isAppBackgrounded() {
        return this.context.document[this.hiddenAttribute];
    }
}
//# sourceMappingURL=browser-lifecycle.js.map